import React from "react";
import twitterIcon from "../../assets/images/twitter_icon.png";
import facebookIcon from "../../assets/images/facebook_icon.png";
import linkdlnIcon from "../../assets/images/linkdln_icon.png";
import * as Scroll from 'react-scroll';
import './Footer.css';

let Link = Scroll.Link;

const Footer = () => {
    return (
        <div className="footer_main">
            <div className="footer_text">
                <ul>
                    <li>
                        <Link
                            to="home"
                            spy={true}
                            smooth={true}
                            duration={500}
                            className={'li_link'}
                            activeClass='li_link'
                        > Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="bio"
                            spy={true}
                            smooth={true}
                            duration={500}
                            className={'li_link'}
                            activeClass='li_link'
                        > Bio
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="benefits"
                            spy={true}
                            smooth={true}
                            duration={500}
                            className={'li_link'}
                            activeClass='li_link'
                        > Benefits
                        </Link>
                    </li>
                    <li>
                        <Link
                            to="contact"
                            spy={true}
                            smooth={true}
                            duration={500}
                            className={'li_link'}
                            activeClass='li_link'
                        > Contact
                        </Link>
                    </li>

                </ul>

                <div>
                    <h5>Social Connect</h5>
                    <div className="text-center">
                    <a href="https://twitter.com/xfunds_trade"><img className={'footer_icon'} src={twitterIcon} alt='twitter' /></a>
                    <a href="https://www.linkedin.com/in/melis-olcay-81428b21b/"><img className={'footer_icon'} src={linkdlnIcon} alt='linkdIn' /></a>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <p>©2022 Melis Olcay and X-Funds by Finzi.</p>
            </div>
        </div>
    )
}

export default Footer;